import { createVNode, render, nextTick } from 'vue';
import { isFunction } from 'es-toolkit';
import { VueFuncallPlugin } from './plugin';
const DEFAULT_OPTIONS = {
    visible: 'modelValue',
    container: document.body
};
export function createFuncall(component, props, options = {}) {
    const wrapper = document.createElement('div');
    const { visible, onClosed: onClosedEvent, container, appContext, slots } = Object.assign({}, DEFAULT_OPTIONS, options);
    const unmount = async () => {
        await nextTick();
        if (vm.el != null) {
            /**
             * Trigger vue renderer unmount logic, such as: `onUnmount` lifecycle.
             */
            render(null, wrapper);
            container.removeChild(wrapper);
        }
    };
    const handleClose = async () => {
        if (vm.component && visible) {
            vm.component.props[visible] = false;
        }
        if (onClosedEvent == null) {
            await unmount();
        }
    };
    const extendProps = {};
    if (onClosedEvent != null) {
        const onClosed = props[onClosedEvent];
        const handleClosed = async (...parameters) => {
            await unmount();
            if (isFunction(onClosed)) {
                onClosed(...parameters);
            }
        };
        extendProps[onClosedEvent] = handleClosed;
    }
    if (visible != null) {
        /**
         * Mount v-model event to listen component close
         */
        extendProps[`onUpdate:${visible}`] = handleClose;
    }
    const vm = createVNode(component, {
        ...props,
        ...extendProps
    }, slots);
    if (appContext ?? VueFuncallPlugin._context) {
        vm.appContext = appContext ?? VueFuncallPlugin._context;
    }
    render(vm, wrapper);
    container.appendChild(wrapper);
    return {
        close: handleClose
    };
}
